"use client";

import { useSite } from "@/lib/hooks/site";
import VenueCardNoImg from "../../list/card/VenueCardNoImg";
import { useState } from "react";
import S3Image from "@/components/S3Image";
import AddPlaceForm from "../Form";
import { useTranslation } from "@/hooks/translationContext";

export default function Entrance() {
  const site: any = useSite();
  const { t } = useTranslation();
  const [heroError, setHeroError] = useState(false);

  const heroFirstPhoto = site.setting?.design?.addVenue?.hero?.firstPhoto?.["1"];

  return (
    <div className="py-2 md:container" id="form">
      <div className="w-full md:flex-row flex-col gap-10 md:items-start items-center md:rounded-[40px] bg-gray-secondary flex justify-between px-6 p-4 md:p-[40px]">
        {!heroFirstPhoto || heroError ? (
          <div className="max-md:hidden w-[636px]">
            <VenueCardNoImg type={0} />
          </div>
        ) : (
          <S3Image
            sizes="(max-width: 600px) 366px, 636px"
            src={`site/${site.id}/assets/${heroFirstPhoto}`}
            width={0}
            height={0}
            className="w-full h-full rounded-[24px] object-cover object-center max-md:hidden"
            alt={t("add-venue-page-hero-photo-alt")}
            onError={() => {
              setHeroError(true);
            }}
          />
        )}
        <div className="w-full text-center">
          <div className="flex flex-col gap-2">
            <h1 className="font-bold text-assistant text-xl md:text-[28px]">
              {t("add-venue-page-first-section-title", {
                defaultValue: `${site.descriptions[0]?.title} sitesine işletmenizi ekleyin işinizi büyütün!`
              })}
            </h1>

            <h3 className="text-sm text-center md:text-base text-assistant font-bold">
              {t("add-venue-page-first-section-description", {
                defaultValue: "Binlerce ziyaretçimize işletmenizi gösterin.",
              })}
            </h3>
          </div>

          <AddPlaceForm formId="first-form" />
        </div>
      </div>
    </div>
  );
}
